// angular
import {Component, inject} from "@angular/core";
import {RouterLink} from "@angular/router";
// material angular
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatIconModule} from "@angular/material/icon";
// components
import {MenuButtonComponent} from "../menu-button/menu-button.component";
import {MessagingMenuComponent} from "../messaging-menu/messaging-menu.component";
import {ProfileMenuComponent} from "../profile-menu/profile-menu.component";
// services
import {UserService} from "@app/shared/services/user.service";
// types
import {IUserData} from "@app/shared/types/employee.type";

import {Role} from "@app/shared/types/role.enum";
// constants
import {appRoutes} from "@app/shared/constants/routes";

@Component({
  selector: "app-mobile-navigation",
  templateUrl: "./mobile-navigation.component.html",
  styleUrls: ["./mobile-navigation.component.scss"],
  standalone: true,
  imports: [
    RouterLink,
    MatToolbarModule,
    MatIconModule,
    MenuButtonComponent,
    MessagingMenuComponent,
    ProfileMenuComponent,
  ],
})
export class MobileNavigationComponent {
  public Role = Role;
  public appRoutes = appRoutes;
  public user: IUserData;

  // dependencies
  private _userService = inject(UserService);

  constructor() {
    this._userService.user$.subscribe((user) => (this.user = user));
  }
}
